import React from 'react';

export const FormDivider = () => {
  return <div>FormDivider</div>;
};
